/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";

export function Routes() {
  // const { isAuthorized } = useSelector(
  //   ({ auth }) => ({
  //     isAuthorized: auth.user != null,
  //   }),
  //   shallowEqual
  // );
  let authToken = localStorage.getItem("authToken");
  const STATE = useSelector(state => state);

  return (
    <Switch>
      {authToken ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Redirect from="/auth" to="/" />
        ) : (
          /*Otherwise redirect to root page (`/`)*/
          <Route>
          <AuthPage />
          </Route>
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {authToken ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Layout>
        <BasePage />
        </Layout>
        ) : (
        <Redirect to="/auth/login" />
      )}
    </Switch>
  );
}
